var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      "\n  Viser " +
        _vm._s(_vm.filteredResidenceNumber) +
        " av " +
        _vm._s(_vm.totalResidenceNumber) +
        " boliger\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }